<template>
  <v-dialog
    :value="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    :fullscreen="true"
    :scrollable="true"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
      @click="active = false"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular pl-5 pr-3"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-2"
          medium
          >mdi-image-outline</v-icon
        >
        {{ $t("fabricDialogPreviewTitle") }}
        <v-spacer></v-spacer>
        <v-btn
          text
          medium
          @click="active = false"
          style="min-width: 0; width: 20px"
        >
          <v-icon
            medium
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            >mdi-close-box</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-card-text class="d-flex ma-0 pa-2" style="background-color: lightgray">
        <v-img
          contain
          style="background-color: lightgray"
          :src="imagePreviewTemplate"
        ></v-img>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-image-preview",
  data() {
    return {};
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    imagePreviewTemplate: {
      //type: String,
      required: true,
    },
  },
  computed: {
    active: {
      get() {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped>
</style>
